(function () {
    const photoPlayerButton = document.getElementById('article-play-yt');

    if (photoPlayerButton) {
        photoPlayerButton.addEventListener('click', () => {
            play();
        })

        photoPlayerButton.addEventListener('touchend', () => {
            play();
        })
    }

    function play() {
        const firstEmbedVideo = document.querySelector('iframe');
        if (firstEmbedVideo) {
            firstEmbedVideo.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            if (firstEmbedVideo.getAttribute('src').includes('youtube')) {
                const ytSrc = firstEmbedVideo.getAttribute('src');
                firstEmbedVideo.setAttribute('src', ytSrc + '?autoplay=1');
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        if(photoPlayerButton) {
            correctVideo();
        }
    })

    function correctVideo() {
        document.querySelectorAll('.article-page__content p').forEach(element => {
            const iframe = element.querySelector('iframe[src*="youtube"]');
            if (iframe) {
                element.style = "position: relative;" +
                    "padding-bottom: 56.25%; /* 16:9 */" +
                    "height: 0;" +
                    "margin-bottom: 30px";

                iframe.style = "  position: absolute;\n" +
                    "  top: 0;" +
                    "  left: 0;" +
                    "  width: 100%;" +
                    "  height: 100%;"
            }
        })
    }
})();
